abstract class ModalFilterGridBinder extends GridBinder {
    parentGridBinder: GridBinder;
    filterKey: string;
    modalFilterButtonEmptyText: string;

    //#region Modal Filter Elements
    modalFilterSelect!: JQuery<HTMLElement>;
    modalFilterSelectOpenedYet!: JQuery<HTMLElement>;
    btnOpenModalFilter!: JQuery<HTMLElement>;
    btnClearModalFilterValue!: JQuery<HTMLElement>;
    //#endregion Modal Filter Elements

    constructor(
        $parent: JQuery<HTMLElement>,
        parentGridBinder: GridBinder,
        filterKey: string,
        options?: Partial<GridBinderOptions>,
    ) {
        const controller = $parent.data("controller");
        const modalFilterButtonEmptyText = $parent.data("empty-button-text");

        super({
            $parent,
            controller,
            searchUrl: "SearchModalFilter",
            bindAdditionalGridButtons: () => {
                this.$parent.findInGrid('div[name="_grid"] button[name="btnSelect"]').on('click', (event) => this.applyModalFilterSelect(event.currentTarget as HTMLElement));
            },
            ...options // 👈 THIS IS IMPORTANT
        });

        //Set Defaults for fall back
        this.parentGridBinder = parentGridBinder;
        this.filterKey = filterKey;
        this.modalFilterButtonEmptyText = modalFilterButtonEmptyText;
    }

    //#region Modal Filter Grid Specific Functions
    bindModalFilter(): void {
        this.modalFilterSelect = this.$parent.findInGrid('.modalFilterSelect');
        this.modalFilterSelectOpenedYet = this.$parent.findInGrid('input[name="ModalOpenedYet"]');
        this.btnOpenModalFilter = this.$parent.findInGrid('button[name="btnOpenModal"]');
        this.btnClearModalFilterValue = this.$parent.findInGrid('button[name="btnClearValue"]');

        this.btnOpenModalFilter.on('click', (event: any) =>
            this.openModalFilter(event.currentTarget as HTMLElement)
        );

        this.btnClearModalFilterValue.on('click', (event: any) =>
            this.clearModalFilterValue(event.currentTarget as HTMLElement)
        );
    }

    openModalFilter(element: HTMLElement): void {
        this.modalFilterSelect.modal('show');

        if (this.modalFilterSelectOpenedYet.val() === 'false') {
            this.modalFilterSelectOpenedYet.val('true');
            this.btnSearch.click();
        }
    }

    applyModalFilterSelect(element: HTMLElement): void {
        const model = this.getModalFilterSelectData(element);

        this.btnOpenModalFilter.text(model.text);

        this.parentGridBinder.setFilterCriteriaValue(this.filterKey, model.value);

        this.parentGridBinder.btnSearch.click();
        this.parentGridBinder.postFilterChange();
    }

    getModalFilterSelectData(element: HTMLElement): any {
        const button = $(element);

        return {
            value: button.val() ?? '',
            text: button.attr('title') ?? ''
        };
    }

    clearModalFilterValue(element: HTMLElement): void {
        this.clearModalFilter();
        this.parentGridBinder.btnSearch.click();
        this.parentGridBinder.postFilterChange();
        this.modalFilterSelect.modal('hide');
    }

    clearModalFilter(): void {
        this.btnOpenModalFilter.text(this.modalFilterButtonEmptyText);
        this.parentGridBinder.setFilterCriteriaValue(this.filterKey, '');
    }
    //#endregion Modal Filter Grid Specific Functions
}